import $ from 'jquery';
import * as jcf from 'jcf/dist/js/jcf';
import toastr from 'toastr/build/toastr.min';
import { setToastr } from './toastr';
// import '../../../../../bower_components/ScrollToFixed/jquery-scrolltofixed';
import './custom-modal';
import Expedicar from './expedicar';
import { numberFormat } from './functions';
import { checkIncompatibilities } from './accessories-incompatibilities';

import CookieManager from './cookie-manager';

function getOutsideColorPrice() {
    let outsideColorPrice = 0;
    const $chekedOutsideColorChoice = $('.chkOutsideColorChoice:checked');

    if ($chekedOutsideColorChoice.length > 0) {
        outsideColorPrice = parseFloat($chekedOutsideColorChoice.data('price'));
    }

    return outsideColorPrice;
}

function getInsideColorPrice() {
    let insideColorPrice = 0;
    const $chekedInsideColorChoice = $('.chkInsideColorChoice:checked');

    if ($chekedInsideColorChoice.length > 0) {
        insideColorPrice = parseFloat($chekedInsideColorChoice.data('price'));
    }

    return insideColorPrice;
}

function getSumOptionnalOptions() {
    let sumOptionnalOptions = 0;

    $('.chkOptionnalOption:checked').each((index, element) => {
        sumOptionnalOptions += parseFloat($(element).data('price'));
    });

    return sumOptionnalOptions;
}

function getSumOptionnalAccessories() {
    let sumOptionnalAccessories = 0;

    const ids = [];
    $('.chkOptionnalAccessory:checked').each((index, element) =>{
        if (ids.indexOf(element.value) === -1) {
            ids.push(element.value);
            sumOptionnalAccessories += parseFloat($(element).data('price'));
        }
    });

    return sumOptionnalAccessories;
}

function getDeliveryPointPrice() {
    if ($('#modalTunnelDevis').hasClass('in')) {
        if ($('#withCarrierQuotation').is(':checked')) {
            return parseFloat($('#selectDeliveryPointCarrierQuotation option:selected').data('price'));
        } else if ($('#withEmotorsQuotation').is(':checked')) {
            return parseFloat($('#selectDeliveryPointEmotorsQuotation option:selected').data('price'));
        } else if ($('#withExpedicarQuotation').is(':checked')) {
            const price = $('#deliveryAddressExpedicarQuotation, #deliveryAddressExpedicar').data('price');
            if ((!price) || isNaN(price)) {
                return 0;
            }
            return parseFloat(price);
        }
    } else {
        if ($('#withCarrier').is(':checked')) {
            return parseFloat($('#selectDeliveryPointCarrier option:selected').data('price'));
        } else if ($('#withEmotors').is(':checked')) {
            return parseFloat($('#selectDeliveryPointEmotors option:selected').data('price'));
        } else if ($('#withExpedicar').is(':checked')) {
            const price = $('#deliveryAddressExpedicarQuotation, #deliveryAddressExpedicar').data('price');
            if ((!price) || isNaN(price)) {
                return 0;
            }
            return parseFloat(price);
        }
    }
    return 0;
}

function getSumServices() {
    let sumServices = 0;

    $('.chkServices:checked').each((index, element) =>{
        sumServices += parseFloat($(element).data('price'));
    });

    return sumServices;
}

function getSumWarranty() {
    let sumWarranty = 0;

    $('.chkWarranty:checked').each((index, element) =>{
        sumWarranty += parseFloat($(element).data('price'));
    });

    return sumWarranty;
}

function getSumAdvantages() {
    let sumAdvantages = 0;

    const $remiseFidelite = $('#remise-fidelite');
    const $remiseParrainage = $('#remise-parrainage');

    if ($remiseFidelite.length === 1) {
        sumAdvantages += parseFloat($remiseFidelite.data('price'));
    }

    if ($remiseParrainage.length === 1) {
        sumAdvantages += parseFloat($remiseParrainage.data('price'));
    }

    return sumAdvantages;
}

function getAdministrativeCostsAmount() {
    const $administrativeCosts = $('#administrativeCosts');
    let administrativeCosts = 0;

    if ($administrativeCosts.length === 1 && $administrativeCosts.is(':checked')) {
        administrativeCosts = parseFloat($administrativeCosts.data('price'));
    }

    return administrativeCosts;
}

function totalPriceSum(
    currentPrice,
    insideColorPrice,
    outsideColorPrice,
    sumOptionnalOptions,
    sumOptionnalAccessories,
    administrativeCosts,
    deliveryPointPrice,
    sumServices,
    sumAdvantages,
) {
    return currentPrice
        + insideColorPrice
        + outsideColorPrice
        + sumOptionnalOptions
        + sumOptionnalAccessories
        + administrativeCosts
        + deliveryPointPrice
        + sumServices
        - sumAdvantages;
}

function updatePrixDeVenteTotal() {
    const emotorsPrice = parseFloat($('#prix-emotors').data('price'));
    let totalPrice;
    const outsideColorPrice = getOutsideColorPrice();
    const sumOptionnalOptions = getSumOptionnalOptions();
    const sumOptionnalAccessories = getSumOptionnalAccessories();
    let deliveryPointPrice = getDeliveryPointPrice();
    let sumServices = getSumServices();
    sumServices += getSumWarranty();
    const insideColorPrice = getInsideColorPrice();
    const sumAdvantages = getSumAdvantages();
    let promotionPrice;
    let promotionTotalPrice;
    const administrativeCosts = getAdministrativeCostsAmount();

    if ($('#prix-promotionnel').data('price') !== 'undefined') {
        promotionPrice = parseFloat($('#prix-promotionnel').data('price'));
    }

    if ($('#selectDeliveryPointQuotation, #selectDeliveryPoint').attr('type') === 'hidden') {
        deliveryPointPrice = parseInt($('#votre-livraison').html(), 10);
    }

    totalPrice = totalPriceSum(
        emotorsPrice,
        insideColorPrice,
        outsideColorPrice,
        sumOptionnalOptions,
        sumOptionnalAccessories,
        administrativeCosts,
        deliveryPointPrice,
        sumServices,
        sumAdvantages,
    );

    if (promotionPrice !== 'undefined') {
        promotionTotalPrice = totalPriceSum(
            promotionPrice,
            insideColorPrice,
            outsideColorPrice,
            sumOptionnalOptions,
            sumOptionnalAccessories,
            administrativeCosts,
            deliveryPointPrice,
            sumServices,
            sumAdvantages,
        );
    }

    $('#prix-de-vente-total')
        .html(numberFormat(totalPrice))
        .data('price', totalPrice)
        .trigger('contentchanged');

    if (promotionTotalPrice !== 'undefined') {
        $('#prix-de-vente-total-promo')
            .html(numberFormat(promotionTotalPrice))
            .data('price', promotionTotalPrice)
            .trigger('contentchanged');
    }
}

function setAssociatedInteriorColor(url, idExteriorColor) {
    const $chkInsideColorChoice = $('.chkInsideColorChoice');
    const currentInsideColorChoice = $('.chkInsideColorChoice:checked').val();

    $chkInsideColorChoice.prop('checked', false);
    jcf.refresh($chkInsideColorChoice);

    $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        data: {
            id: idExteriorColor,
        },
    }).done((data) => {
        $chkInsideColorChoice.parent().parent().parent().parent().addClass('gris1');
        $chkInsideColorChoice.parent().parent().addClass('disabled');
        $chkInsideColorChoice.attr('disabled', '');

        $(data).each((key, value) => {
            const input = $('.chkInsideColorChoice[value="' + value.id + '"]');
            const element = input.parent().parent();
            input.removeAttr('disabled');
            element.removeClass('disabled');
            element.parent().parent().removeClass('gris1');

            if (currentInsideColorChoice === value.id) {
                input.prop('checked', true);
                jcf.refresh(input);
                updatePrixDeVenteTotal();
            }
        });
    });
}

function setAssociatedExteriorColor(url, idInteriorColor) {
    const $chkOutsideColorChoice = $('.chkOutsideColorChoice');
    const currentOutsideColorChoice = $('.chkOutsideColorChoice:checked').val();

    $chkOutsideColorChoice.prop('checked', false);
    jcf.refresh($chkOutsideColorChoice);

    $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        data: {
            id: idInteriorColor,
        },
    }).done((data) => {
        $chkOutsideColorChoice.parent().parent().parent().parent().addClass('gris1');
        $chkOutsideColorChoice.parent().parent().addClass('disabled');
        $chkOutsideColorChoice.attr('disabled', '');

        $(data).each((key, value) =>{
            const input = $('.chkOutsideColorChoice[value="' + value.VNCID + '"]');
            const element = input.parent().parent();
            input.removeAttr('disabled');
            element.removeClass('disabled');
            element.parent().parent().removeClass('gris1');

            if (currentOutsideColorChoice === value.VNCID) {
                input.prop('checked', true);
                jcf.refresh(input);
                updatePrixDeVenteTotal();
            }
        });
    });
}

function sendCarSheetLinkToCustomer(url, idCar, number){
    let result = [];
    $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        async: false,
        data: {
            carId: idCar,
            number,
        },
    }).done((data) => {
        result = data;
    });

    return result;
}

/**
 * Met à jour l'élément d'identifiant "votre-livraison".
 *
 * @param price Prix à afficher
 */
function updateVotreLivraisonField(price) {
    $('#votre-livraison')
        .html(numberFormat(price))
        .data('price', price);
}

/**
 * Fonction appelée lorsque le lieu de livraison a été modifié.
 */
function onDeliveryChange() {
    updateVotreLivraisonField(getDeliveryPointPrice());
    updatePrixDeVenteTotal();
}

/**
 * Fonction appelée lorsque le mode de livraison a été modifié.
 *
 * @param radioToUpdate Bouton radio à mettre en concordance avec celui qui a été sélectionné.
 */
function onDeliveryModeChange(radioToUpdate) {
    radioToUpdate.click();

    onDeliveryChange();
}

/**
 * Fonction appelée lorsque l'utilisateur a choisi la mise à disposition par E-Motors.
 *
 * @param radioToUpdate Bouton radio à mettre en concordance avec celui qui a été sélectionné.
 */
function onSelectEMotorsDelivery(radioToUpdate) {
    $('.containerDeliveryPointEmotors').removeClass('hide');
    $('.containerDeliveryPointWithExpedicar').addClass('hide');
    $('.containerDeliveryPointCarrier').addClass('hide');

    onDeliveryModeChange(radioToUpdate);
}

/**
 * Fonction appelée lorsque l'utilisateur a choisi la livraison par Expedicar.
 *
 * @param radioToUpdate Bouton radio à mettre en concordance avec celui qui a été sélectionné.
 */
function onSelectExpedicarDelivery(radioToUpdate) {
    $('.containerDeliveryPointEmotors').addClass('hide');
    $('.containerDeliveryPointWithExpedicar').removeClass('hide');
    $('.containerDeliveryPointCarrier').addClass('hide');

    onDeliveryModeChange(radioToUpdate);
}

/**
 * Fonction appelée lorsque l'utilisateur a choisi la livraison par transporteur.
 *
 * @param radioToUpdate Bouton radio à mettre en concordance avec celui qui a été sélectionné.
 */
function onSelectCarrierDelivery(radioToUpdate) {
    $('.containerDeliveryPointEmotors').addClass('hide');
    $('.containerDeliveryPointWithExpedicar').addClass('hide');
    $('.containerDeliveryPointCarrier').removeClass('hide');

    onDeliveryModeChange(radioToUpdate);
}

/**
 * Fonction appelée lorsque l'utilisateur a sélectionné un point de livraison.
 *
 * @param initialSelect "select" modifié par l'utilisateur
 * @param selectToUpdate "select" à mettre en concordance
 */
function onSelectDeliveryPointChange(initialSelect, selectToUpdate) {
    const valSelected = initialSelect.children('option:selected').val();

    selectToUpdate.children(`option[value="${valSelected}"]`).prop('selected', true);

    onDeliveryChange();
}

$(document).ready(() => {
    let mainColorSelection = null;

    $('#secDesc').on('show.bs.collapse', () => {
        $('#readMoreDesc').html('Réduire le texte <i class="icon-arrow-up"></i>');
    }).on('hide.bs.collapse', () => {
        $('#readMoreDesc').html('<span class="bleuEM">...</span> Lire la suite <i class="icon-arrow-down"></i>');
    });

    // Couleur exterieur
    // Options aux choix
    $('.chkOptionnalOption').change(() => {
        let vosOptions = getSumOptionnalOptions();

        $('#vos-options')
            .html(numberFormat(vosOptions))
            .data('price', vosOptions)
        ;

        updatePrixDeVenteTotal();
    });

    $('.chkOutsideColorChoice').change((element) => {
        const $this = $(element.currentTarget);
        const outsideColorPrice = getOutsideColorPrice();

        if (mainColorSelection.attr('class') === $this.attr('class')) {
            setAssociatedInteriorColor($this.data('pathinteriorcolor'), $this.val());
        }

        $('#recap-exterior-color')
            .html(numberFormat(outsideColorPrice))
            .data('price', outsideColorPrice)
        ;
        updatePrixDeVenteTotal();
    });

    $('.chkInsideColorChoice').change((element) => {
        const $this = $(element.currentTarget);
        const insideColorPrice = getInsideColorPrice();

        if (mainColorSelection !== null && mainColorSelection.attr('class') === $this.attr('class')) {
            setAssociatedExteriorColor($this.data('pathexteriorcolor'), $this.val());
        }

        $('#recap-interior-color')
            .html(numberFormat(insideColorPrice))
            .data('price', insideColorPrice)
        ;
        updatePrixDeVenteTotal();
    });

    $('.labelInsideColorChoice').click((element) => {
        const $this = $(element.currentTarget);
        const $chkInsideColorChoice = $('.chkInsideColorChoice');
        const $chkOutsideColorChoice = $('.chkOutsideColorChoice');
        const isChkInsideColorChoiceDisabled = $this.find('.chkInsideColorChoice').is(':disabled');

        if (mainColorSelection === null || isChkInsideColorChoiceDisabled) {
            mainColorSelection = $chkInsideColorChoice;
        }

        if (isChkInsideColorChoiceDisabled) {
            // on remet à jour la partie couleur interieur
            $('#recap-exterior-color')
                .html(numberFormat(0))
                .data('price', 0)
            ;
            $chkInsideColorChoice.prop('checked', false);
            jcf.refresh($chkInsideColorChoice);
            $chkInsideColorChoice.parent().parent().parent().parent().removeClass('gris1');
            $chkInsideColorChoice.parent().parent().removeClass('disabled');
            $chkInsideColorChoice.removeAttr('disabled');

            $chkOutsideColorChoice.prop('checked', false);
            jcf.refresh($chkOutsideColorChoice);
            $chkOutsideColorChoice.parent().parent().parent().parent().addClass('gris1');
            $chkOutsideColorChoice.parent().parent().addClass('disabled');
            $chkOutsideColorChoice.attr('disabled');
        }
    });

    $('.labelExteriorColorChoice').click((element) => {
        const $this = $(element.currentTarget);
        const $chkInsideColorChoice = $('.chkInsideColorChoice');
        const $chkOutsideColorChoice = $('.chkOutsideColorChoice');
        const ischkOutsideColorChoiceDisabled = $this.find('.chkOutsideColorChoice').is(':disabled');

        if (mainColorSelection === null || ischkOutsideColorChoiceDisabled) {
            mainColorSelection = $chkOutsideColorChoice;
        }

        if (ischkOutsideColorChoiceDisabled) {
            // on remet à jour la partie couleur exterieur
            $('#recap-interior-color')
                .html(numberFormat(0))
                .data('price', 0)
            ;
            $chkOutsideColorChoice.prop('checked', false);
            jcf.refresh($chkOutsideColorChoice);
            $chkOutsideColorChoice.parent().parent().parent().parent().removeClass('gris1');
            $chkOutsideColorChoice.parent().parent().removeClass('disabled');
            $chkOutsideColorChoice.removeAttr('disabled');

            $chkInsideColorChoice.prop('checked', false);
            jcf.refresh($chkInsideColorChoice);
            $chkInsideColorChoice.parent().parent().parent().parent().addClass('gris1');
            $chkInsideColorChoice.parent().parent().addClass('disabled');
            $chkInsideColorChoice.attr('disabled');
        }
    });

    function updateAccessoriesAndServices(incompatibilities, $this) {
        let sumServices;
        let sumOptionnalAccessories;

        checkIncompatibilities(incompatibilities, 'chkOptionnalAccessory', $this);
        checkIncompatibilities(incompatibilities, 'chkServices', $this);

        sumServices = getSumServices();

        $('#vos-services')
            .html(numberFormat(sumServices))
            .data('price', sumServices)
        ;

        sumOptionnalAccessories = getSumOptionnalAccessories();

        $('#vos-accessoires')
            .html(numberFormat(sumOptionnalAccessories))
            .data('price', sumOptionnalAccessories)
        ;

        updatePrixDeVenteTotal();
    }

    // Accessoires
    $('.chkOptionnalAccessory').change(function (event) {
        const $this = $(event.currentTarget);
        const sameAccessories = $('input[name="accessory[]"][value="' + event.currentTarget.value + '"]');
        sameAccessories.prop('checked', $this.prop('checked'));
        jcf.refresh(sameAccessories);
        const incompatibilities = $this.attr('data-incompatibilities');
        updateAccessoriesAndServices(incompatibilities, $this);
    });

    $('#withEmotors').change(() => {
        onSelectEMotorsDelivery($('#withEmotorsQuotation'));
    });

    $('#withEmotorsQuotation').change(() => {
        onSelectEMotorsDelivery($('#withEmotors'));
    });

    $('#withExpedicar').change(() => {
        onSelectExpedicarDelivery($('#withExpedicarQuotation'));
    });

    $('#withExpedicarQuotation').change(() => {
        onSelectExpedicarDelivery($('#withExpedicar'));
    });

    $('#withCarrier').change(() => {
        onSelectCarrierDelivery($('#withCarrierQuotation'));
    });

    $('#withCarrierQuotation').change(() => {
        onSelectCarrierDelivery($('#withCarrier'));
    });

    $('#selectDeliveryPointEmotors').change(() => {
        onSelectDeliveryPointChange($('#selectDeliveryPointEmotors'), $('#selectDeliveryPointEmotorsQuotation'));
    });

    $('#selectDeliveryPointEmotorsQuotation').change(() => {
        onSelectDeliveryPointChange($('#selectDeliveryPointEmotorsQuotation'), $('#selectDeliveryPointEmotors'));
    });

    $('#selectDeliveryPointCarrier').change(() => {
        onSelectDeliveryPointChange($('#selectDeliveryPointCarrier'), $('#selectDeliveryPointCarrierQuotation'));
    });

    $('#selectDeliveryPointCarrierQuotation').change(() => {
        onSelectDeliveryPointChange($('#selectDeliveryPointCarrierQuotation'), $('#selectDeliveryPointCarrier'));
    });

    // Services
    $('.chkServices').change((event) => {
        const $this = $(event.currentTarget);
        const incompatibilities = $this.attr('data-incompatibilities');

        updateAccessoriesAndServices(incompatibilities, $this);
    });

    // Services
    $(document).on('change', '.chkWarranty', function () {
        const sumWarranty = getSumWarranty();
        updatePrixDeVenteTotal();
    });

    $(document).on('click', '.chkOutsideColorChoice', function () {
        var redirectLink = $(this).attr('data-redirect');

        var valFormSave = [];

        $('.containInformationsFicheVehicule input:checked:enabled:not(.chkOutsideColorChoice), .containInformationsFicheVehicule select').each(function () {
            if ($(this).val() != '' && ($(this).attr('name') != undefined || $(this).attr('id') != undefined) || $(this).attr('class')) {
                valFormSave.push({
                    name: $(this).attr('name'),
                    val: $(this).val(),
                    dataId: $(this).data('id'),
                    id: $(this).attr('id'),
                    balise: this.tagName,
                    class: $(this).attr('class'),
                    type: $(this).attr('type'),
                });
            }
        });

        CookieManager.setCookie('saveForm', JSON.stringify(valFormSave));

        if (redirectLink != null && redirectLink != '') {
            window.location.href = redirectLink + '?loadForm=1';
        }
    });

    if (CookieManager.getCookie('saveForm') !== null) {
        /** rechargement du formulaire */
        if (/loadForm=1(?![0-9]+)/.test(document.location.href)) {
            const saveForm = JSON.parse(CookieManager.getCookie('saveForm'));

            $.each(saveForm, function (key, value) {
                let selector = '.containInformationsFicheVehicule ' + value.balise.toLowerCase();
                if (typeof value.dataId !== 'undefined') {
                    selector += '[data-id="' + value.dataId + '"]';
                } else if (typeof value.name !== 'undefined') {
                    selector += '[name="' + value.name + '"]';
                }

                if (typeof value.class !== 'undefined') {
                    selector += '.' + value.class.replace(/[\s]+/, '.');
                }
                if (typeof value.id !== 'undefined') {
                    selector += '#' + value.id.replace(/[\s]+/, '#');
                }

                if ($(selector).length > 1) {
                    if (typeof value.val !== 'undefined') {
                        selector += '[value="' + value.val + '"]';
                    }
                }

                if (value.balise === 'INPUT') {
                    switch (value.type) {
                    case 'checkbox':
                    case 'radio':
                        if (!$(selector).is(':checked')) {
                            $(selector).trigger('click');
                        }
                        break;
                    }
                } else if (value.balise === 'SELECT') {
                    $(selector).val(value.val);

                    setTimeout(function () {
                        jcf.refresh($(selector));
                    }, 2000);
                }
            });
        } else {
            delete CookieManager.deleteCookie('saveForm');
        }
    }

    $(document).on('click', '#boutonSendCarSheetBySMS', function (event) {
        const $this = $(event.currentTarget);
        const url = $this.data('send-sms-path');
        const idCar = $this.data('id-car');
        let number = $('#telSendCarSheetBySMS').val();
        number = number.replace(/ /g, '');
        const result = sendCarSheetLinkToCustomer(url, idCar, number);

        if (result.result) {
            setToastr(toastr, 'Le sms a bien été envoyé', 'success');
            $('#blockSendSMSCarSheet').hide();
        } else {
            switch (result.message) {
            case 'not valid number':
                setToastr(toastr, 'Le numéro que vous avez entré n\'est pas valide', 'error');
                break;
            case 'message already sended':
                setToastr(toastr, 'Ce numéro peut être utilisé qu\'une fois par jour pour l\'envoi d\'une fiche', 'error');
                break;
            default:
                setToastr(toastr, 'Une erreur est survenue', 'error');
                break;
            }
        }
    });

    const expedicar = new Expedicar();

    expedicar.on('finish', () => updatePrixDeVenteTotal());
    expedicar.on('success', (price) => updateVotreLivraisonField(price));

    //  Calcul du coût de livraison par Expedicar lorsque l'utilisateur saisit l'adresse dans l'onglet "Services" (page car_sheet.html.twig)
    $('#deliveryAddressExpedicar, #deliveryZipCodeExpedicar, #deliveryCityExpedicar, #deliveryCountryExpedicar').keyup(() => {
        expedicar.onExpedicarChange('');
    });

    //  Calcul du coût de livraison par Expedicar lorsque l'utilisateur saisit l'adresse dans la pop-in de demande de devis (page car_sheet.html.twig)
    $('#deliveryAddressExpedicarQuotation, #deliveryZipCodeExpedicarQuotation, #deliveryCityExpedicarQuotation, #deliveryCountryExpedicarQuotation').keyup(() => {
        expedicar.onExpedicarChange('Quotation');
    });

    // Changement d'option Expedicar dans l'onglet "Services" (page car_sheet.html.twig)
    $('#expedicarWithHandoverService, #expedicarWithExteriorWashing').change(() => {
        expedicar.onExpedicarChange('');
    });

    // Changement d'option Expedicar dans la pop-in de demande de devis (page car_sheet.html.twig)
    $('#expedicarWithHandoverServiceQuotation, #expedicarWithExteriorWashingQuotation').change(() => {
        expedicar.onExpedicarChange('Quotation');
    });

    // Changement de la valeur de la garantie dans les caractéristiques techniques
    $('.warrantyExtensionEnable').click((event) => {
        const $warrantyExtensionEnable = $(event.currentTarget);
        $('.label-warranty-extension').hide();
        $('.label-warranty-without-extension').hide();
        $(`.label-warranty-extension-${$warrantyExtensionEnable.val()}`).show();
        $(`.chkWarrantyAccessory`).prop('checked', false);
        $(`.chkWarrantyAccessory[value|="${$warrantyExtensionEnable.val()}"]`).prop('checked', true);
    });

    $('.warrantyExtensionDisable').click(() => {
        $('.label-warranty-extension').hide();
        $('.label-warranty-without-extension').show();
        $('.chkWarrantyAccessory').prop('checked', false);
    });

    $('.chkWarrantyAccessory').click((event) => {
        const $chkWarrantyAccessory = $(event.currentTarget);
        const warrantyId = $chkWarrantyAccessory.val();
        const isChecked = $chkWarrantyAccessory.is(':checked');
        if (isChecked) {
            $(`.chkWarranty[value|="${warrantyId}"]`).click();
        } else {
            $('.warrantyExtensionDisable').click();
        }

    });

    $('#administrativeCosts').change(() => {
        const administrativeCostsAmount = getAdministrativeCostsAmount();
        $('#vos-frais-administratifs')
            .html(numberFormat(administrativeCostsAmount))
            .data('price', administrativeCostsAmount)
        ;
        updatePrixDeVenteTotal();
    });
});
